import { Reducer } from "redux";

import { GeneratedVideoUrlResponse } from "../models/api/Training";
import { GeneratedVideoUrlDispatchTypes } from "../models/dispatchTypes/Training";
import { GetGeneratedVideoUrlActionDispatchTypes } from "../constants/Training";

const initialState: GeneratedVideoUrlResponse = {
  loading: false,
  response: {
    url: "",
  },
  error: null,
};

const GeneratedVideoUrlReducer: Reducer<
  GeneratedVideoUrlResponse,
  GeneratedVideoUrlDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case GetGeneratedVideoUrlActionDispatchTypes.GET_GENERATED_VIDEO_URL_RESET: {
      return initialState;
    }
  }
  return state;
};

export default GeneratedVideoUrlReducer;
